import { useState } from "react";

import { CopyIcon, SuccessIcon } from "@/assets/icons";
import { Button } from "@/atoms";
import { strings } from "@/constants";
import { ButtonSizeEnum, ButtonVariantEnum } from "@/enums";

export const CopyableLink = ({
    label,
    url,
}: {
    label?: string,
    url: string,
}) => {
    const [isCopied, setIsCopied] = useState(false);

    const copyHandler = async () => {
        try {
            await navigator.clipboard.writeText(url);

            setIsCopied(true);

            setTimeout(
                () => setIsCopied(false),
                2000,
            );
        } catch {
            setIsCopied(false);
        }
    };

    return (
        <div
            className="
                flex
                w-full
                flex-col
                gap-2
            "
        >
            {label && (
                <span
                    className="
                        text-xs
                        font-semibold
                        tracking-wide
                        text-text-secondary
                        uppercase
                    "
                >
                    {label}
                </span>
            )}
            <div
                className="
                    flex
                    w-full
                    items-stretch
                    gap-2
                    rounded-default
                    border
                    border-gray-200
                    bg-gray-50
                    p-1.5
                    pl-3
                "
            >
                <span
                    title={url}
                    className="
                        block
                        min-w-0
                        flex-1
                        truncate
                        self-center
                        font-mono
                        text-sm
                        text-text-primary
                    "
                >
                    {url}
                </span>
                <Button
                    aria-label={strings.common.copy}
                    className="
                        inline-flex
                        shrink-0
                        items-center
                        justify-center
                        gap-1.5
                    "
                    size={ButtonSizeEnum.SM}
                    variant={isCopied ? ButtonVariantEnum.MUTED : ButtonVariantEnum.PRIMARY}
                    onClick={copyHandler}
                >
                    {isCopied
                        ? (
                            <>
                                <SuccessIcon className="size-3.5" />
                                {strings.common.copied}
                            </>
                        )
                        : (
                            <>
                                <CopyIcon className="size-3.5" />
                                {strings.common.copy}
                            </>
                        )}
                </Button>
            </div>
        </div>
    );
};
